<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-delete</v-icon>Eliminar conta
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <span>Tem certeza que pretende eliminar a sua conta? <br /></span>
              <span
                >Poderá levar até 1 ano para voltar a ter uma conta Kyami.</span
              >
            </v-card-text>
            <v-card-text class="m-txt-center" style="color: red;">
              <div style="color: red; border: 1px solid red; padding: 5px">
                <span>FACTORY DROP<br /></span>
              </div>
            </v-card-text>
            <v-card-text>
              <v-text-field
                filled
                label="Digite o texto  acima"
                class="purple-input"
                v-model="text"
                :rules="textRules"
                required
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="error lighten-2"
                text
                block
                @click="deleteEntity"
                :disabled="!valid"
                :loading="loading"
              >
                Eliminar a minha conta
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" text @click="resetValidation">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "DeleteEntity",
  data: () => ({
    dialog: false,
    valid: false,
    value: true,
    loading: false,
    text: "",
    textRules: [v => !!v || "", v => (v && v === "FACTORY DROP") || ""]
  }),
  methods: {
    deleteEntity() {
      if (this.$refs.form.validate()) {
        let credit = {
          credit: this.$store.getters.getBalanceEnterprise
        };
        this.$store.dispatch("deleteEnterprise", credit);
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.text = "";
      this.dialog = false;
    }
  },
  created() {
    const self = this;
    eventBus.$on("openDeleteEntity", function(value) {
      self.dialog = value;
    });
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
